class CegoXMPPUsers {
    constructor(gameName, CegoXMPP) {
        this.gameName = gameName;
        this.CegoXMPP = CegoXMPP;
        this.USERS_CACHE = [];
        this.USERS_TO_FETCH = [];
        this.updateUserObject(CegoXMPP.user.u, CegoXMPP.user);
    };

    getUserObject(username, callback) {
        if (!username || username === "undefined" || username.indexOf("-") >= 0 || username.indexOf("_") >= 0) {
            return;
        }
        let user = this._getFromCache(username);
        if (!user || typeof user.id !== "number") {
            this.fetchUser(username, callback);
        } else {
            if (typeof callback === "function") {
                callback(user);
            }
        }
    }

    fetchUser(username, callback) {
        if (username) {
            if (typeof this.USERS_TO_FETCH[username] === "undefined") {
                this.USERS_TO_FETCH[username] = [];
                this.USERS_TO_FETCH[username].push(callback);
                $.ajax(this.CegoXMPP.SETTINGS.ajaxScript.getUser + "/" + username + "/" + (this.gameName ? this.gameName : "none") + "/data.json",
                    {
                        success: (data) => {
                            if (typeof data[username] !== "undefined") {
                                this.updateUserObject(username, data[username]);
                                for (let i in this.USERS_TO_FETCH[username]) {
                                    this.USERS_TO_FETCH[username][i](data[username]);
                                }
                                delete this.USERS_TO_FETCH[username];
                            }
                        }
                    });
            } else {
                this.USERS_TO_FETCH[username].push(callback);
            }
        }
    }

    _getFromCache(username) {
        if (this.USERS_CACHE[username]) {
            return this.USERS_CACHE[username];
        } else {
            const cache = app.storage.get("user:" + username);
            if (cache) {
                const user = JSON.parse(cache);
                if (typeof user.v === "boolean") {
                    this.USERS_CACHE[username] = JSON.parse(cache);
                    return this.USERS_CACHE[username];
                } else {
                    app.storage.cleanByPrefix("user:");
                }
            }
        }

        return null;
    }

    removeUserObject(username) {
        app.storage.remove("user:" + username);
        this.USERS_CACHE[username] = null;
    }

    updateUserObject(username, obj) {
        if (this._getFromCache(username)) {
            let newGameRank = {};
            const gameRank = this.USERS_CACHE[username].g;
            this.USERS_CACHE[username] = obj;
            jQuery.extend(newGameRank, gameRank, this.USERS_CACHE[username].g);
            this.USERS_CACHE[username].g = newGameRank;
        } else {
            this.USERS_CACHE[username] = obj;
        }

        if (this.isMe(username)) {
            this.CegoXMPP.user = this.USERS_CACHE[username];
        }
        app.storage.set("user:" + username, JSON.stringify(this.USERS_CACHE[username]));
    }

    isMe(username) {
        return app.config.user.u === username;
    }

    isIgnoredUser(username) {
        if (typeof this.CegoXMPP.ignoredUsers[username] === "boolean") {
            return this.CegoXMPP.ignoredUsers[username];
        }
        return false;
    }

    isAdminUser(username) {
        return app.config.moderators.indexOf(username) >= 0;
    }

    isStaff(username) {
        return app.config.staff.indexOf(username) >= 0;
    }

    isBlocked(username) {
        if (this.isMe(username) || this.isAdminUser(username) || this.isAdminUser(app.config.user.u) || this.isStaff(username) || this.isStaff(app.config.user.u)) {
            return false;
        }
        let user = this._getFromCache(username);
        if (user) {
            if (typeof user.b === "object") {
                for (let i in user.b) {
                    if (user.b[i] === app.config.user.u) {
                        return true;
                    }
                }
            }
        }

        if (typeof app.config.user.b === "object") {
            for (let i in app.config.user.b) {
                if (app.config.user.b[i] === username) {
                    return true;
                }
            }
        }

        return false;
    }

    isBanned(username) {
        if (app.config.banned.length) {
            return app.config.banned.indexOf(username) >= 0;
        }
    }

    isMuted(username) {
        if (typeof app.config.muted === "object") {
            if (typeof app.config.muted[username] !== "undefined") {
                if (typeof app.config.muted[username].expires === "number" && app.config.muted[username].expires <= app.util.getTimeNow()) {
                    delete app.config.muted[username];
                    return false;
                }
                return true;
            }
        }
    }

    removeBlocked(username) {
        if (this.isMe(username)) {
            return;
        }
        const userItems = jQuery("[data-username='" + username + "']");
        if (userItems.length) {
            userItems.slideUp(100, () => userItems.remove());
        }
    }

    getProfileImage(user) {
        if (typeof user.pi === "undefined") {
            return "/services/media/images/zekyvxdlwocoqrws/profile-thumb/noimage.jpg";
        }
        if (user.pi.length > 20) {
            return user.pi;
        } else {
            return "/services/media/images/" + user.pi + "/profile-thumb/" + user.u + ".jpg"
        }
    }
}